import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_ActionButton.scss'

const ActionButton = ({
  buttonText
  , children
  , onClick
  , className
  , preventDefault
  , buttonClassName
  , buttonTextClassName
  , buttonChildrenClassName
  , variant
  , size
  , ...props
}) => (
  <Button
    style={variant !== 'link' ? {cursor: 'pointer', color: 'white'} : {cursor: 'pointer', color: '#26b0e1', fontSize: '16px'}}
    className={className + ' ' + buttonClassName}
    {...props}
    onClick={(event) => {
      handleClick(event, preventDefault, onClick)
      return false
    }}
    variant={variant || 'default'}
    size={size}>
    <span className={buttonTextClassName}>{buttonText}</span>
    <span className={buttonChildrenClassName}>{children}</span>
  </Button>
  )

ActionButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.any,
  preventDefault: PropTypes.bool,
  buttonClassName: PropTypes.string,
  buttonTextClassName: PropTypes.string,
  buttonChildrenClassName: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string
}

export default (ActionButton)

function isLeftClickEvent (event) {
  return event.button === 0
}

function isModifiedEvent (event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
}

function handleClick (event, preventDefault, callBack) {
  if (callBack) {
    callBack(event)
  }

  if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
    return
  }

  if (event.defaultPrevented === true) {
    return
  }

  if (preventDefault) {
    event.preventDefault()
  }
}
